/**
 * Mock registry for API client - tests override responses without hitting the backend.
 * Keys: 'loader:<path>', 'action:<name>', 'intent:<name>'
 */

import type { ApiResponse } from "./types";

export type MockResponse = ApiResponse<unknown> | (() => ApiResponse<unknown>);

const mockRegistry = new Map<string, MockResponse>();

export function getMockKey(
  endpoint: string,
  method: string,
  body?: unknown,
): string | null {
  if (method === "GET" && endpoint.startsWith("/loader/")) {
    return "loader:" + endpoint.slice("/loader/".length);
  }
  if (
    method === "POST" &&
    endpoint === "/action" &&
    body &&
    typeof body === "object"
  ) {
    const b = body as Record<string, unknown>;
    if (typeof b.action === "string") return "action:" + b.action;
    if (typeof b.intent === "string") return "intent:" + b.intent;
  }
  return null;
}

export function getMock<T>(
  key: string,
): ApiResponse<T> | (() => ApiResponse<T>) | undefined {
  return mockRegistry.get(key) as
    | ApiResponse<T>
    | (() => ApiResponse<T>)
    | undefined;
}

export function setMock(key: string, result: MockResponse): void {
  mockRegistry.set(key, result);
}

export function setMockFailure(key: string, errorMessage: string): void {
  mockRegistry.set(key, { success: false, data: null, error: errorMessage });
}

export function clearMock(key: string): void {
  mockRegistry.delete(key);
}

export function clearMocks(): void {
  mockRegistry.clear();
}
